// „Bewegung reduzieren“ für alle Grafiken: Systemeinstellung ODER Einstellung „Animationen aus“ (Version 3).
// Ersetzt den direkten Import aus framer-motion, damit das Umschalten sofort wirkt.
import { useReducedMotion as useSystemReducedMotion } from "framer-motion";
import { useMotionOff } from "./motionPref";

export const useReducedMotion = () => {
    const system = useSystemReducedMotion();
    const off = useMotionOff();
    return off || !!system;
};

export default useReducedMotion;
